import "./AffordableSeoServicesUk.module.css";
import Header from "@/reusable_sections/Header";
import AffordableHero from "./sections/AffordableHero";
import SmallBusinessFocus from "./sections/SmallBusinessFocus";
import AffordableComparison from "./sections/AffordableComparison";
import Advantages from "./sections/Advantages";
import Process from "./sections/Process";
import Proof from "./sections/Proof";
import Audience from "./sections/Audience";
import Pricing from "./sections/Pricing";
import AffordableFaq from "./sections/AffordableFaq";
import Conversion from "./sections/Conversion";
import Footer from "@/reusable_sections/Footer";
export default function AffordableSeoServicesUkPage() {
  return <div>
      <Header />
      <AffordableHero />
      <SmallBusinessFocus />
      <AffordableComparison />
      <Advantages />
      <Process />
      <Proof />
      <Audience />
      <Pricing />
      <AffordableFaq />
      <Conversion />
      <Footer />
    </div>;
}